module.exports = __webpack_public_path__ + "media/images/flags/LT-1adee498bb2aa569a3c3f0d8188e4d76.svg";